import parseISO from 'date-fns/parseISO'

import type { Seminar } from 'services/seminars/types'
import Link from 'content-components/_Primatives/Link'
import { formatStartEndDate } from 'ui-component-library/utils/helpers'
import style from './style.scss'

const hideCountry = new Set(['US', 'CA'])

function formatLocation({
  city,
  country,
  state,
}: {
  city: string
  country: string
  state?: string
}) {
  return [city, state, hideCountry.has(country) ? '' : country]
    .filter(Boolean)
    .join(', ')
}

type Props = {
  result: Seminar
}

function CourseItem(props: Props) {
  const { result } = props
  const {
    detailsPageUrl,
    dailyListShortName,
    isOnlineSeminar,
    startDate,
    endDate,
    city,
    country,
    state,
  } = result

  const locationText = isOnlineSeminar
    ? 'Online'
    : formatLocation({
        city,
        country,
        state,
      })

  const dateText = formatStartEndDate(parseISO(startDate), parseISO(endDate))
  return (
    <li>
      <Link url={detailsPageUrl} className={style.wrapper}>
        <div className={style.locationText}>{locationText}</div>
        <div>{dailyListShortName}</div>
        <div>{dateText}</div>
      </Link>
    </li>
  )
}

export default CourseItem
